import produce from '../../produce';

import * as types from './types';
import { navigation as staticNavigation, navigationVariation as staticNavigationVariation } from '../../../navigation';
import { navigation as staticMobileNavigation } from '../../../cms-generals';

const initialState = {
  desktop: staticNavigation,
  mobile: staticMobileNavigation,
  desktopVariation: staticNavigationVariation
};

/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.NAVIGATION_SET_DESKTOP:
      draft.desktop = action.payload;
      break;

    case types.NAVIGATION_SET_MOBILE:
      draft.mobile = action.payload;
      break;

    // eslint-disable-next-line import/namespace
    case types.NAVIGATION_SET_DESKTOP_VARIATION:
      draft.desktopVariation = action.payload;
      break;
  }
}, initialState);

export default reducer;
